import { FileUpload } from '@insurancemenu/imenu-components-lib';
import {
  REJECTED_FILE_MESSAGES,
  UPLOAD_FILE_TYPES,
} from '@insurancemenu/imenu-components-lib/dist/components/FileUpload';
import ActionModal from '@insurancemenu/imenu-components-lib/dist/components/modals/ActionModal';
import { ModalType } from 'global/utils/ModalsHelper';
import { observer } from 'mobx-react-lite';
import React from 'react';
import { useRFQBenefitSummaryPageStore } from 'store/pages/rfq/rfq-template/rfq-benefit-summary/pageStore';
import { FileUploadStyled } from './styles';

const UploadDocumentModal: React.FC = observer(() => {
  const {
    showUploadDocumentModal,
    uploadDocumentModalDelegate: { isLoading, fileUploadDelegate, uploadDocument },
    closeUploadDocumentModal,
  } = useRFQBenefitSummaryPageStore();

  return (
    <ActionModal
      show={showUploadDocumentModal}
      title="Upload Document"
      subtitle="The document will be listed in your plan attributes."
      modalType={ModalType.NO_ICON}
      closeButtonText="Cancel"
      onClose={closeUploadDocumentModal}
      actionButtonText="Upload Document"
      onAction={uploadDocument}
      loading={isLoading}
      modalContent={
        <FileUploadStyled>
          <FileUpload
            fileMimeTypes={[UPLOAD_FILE_TYPES.pdf]}
            allowMultipleFiles={false}
            messageForRejectedFiles={REJECTED_FILE_MESSAGES.pdf}
            shouldBeReset={fileUploadDelegate.isFileUploadReset}
            onChange={fileUploadDelegate.setFiles}
          />
        </FileUploadStyled>
      }
      isValid={!fileUploadDelegate.noUploadedFiles}
    />
  );
});

export default UploadDocumentModal;
